module.exports = "/assets/7b82418c2198159fcbed43af1dc52dab.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XF.png
// module id = 1994
// module chunks = 0